import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath, betMoney, closeMenuAndScrollToTop} from 'app/utils';
import FrozenBalance from 'app/interfaces/FrozenBalanceInterface';
import UserBalanceInterface from 'app/interfaces/UserBalanceInterface';
import AvatarEditorWithName from 'app/components/user/AvatarEditorWithName';
import BalanceUserStatus from 'app/components/user/BalanceUserStatus';
import CashbackBalanceTooltip from 'app/components/user/CashbackBalanceTooltip';
import FrozenBalanceTooltip from 'app/components/user/FrozenBalanceTooltip';
import {userStore} from 'app/store/global';
import {pushAnalyticsEvent} from 'app/utils/analytics';

interface UserBalanceState {
    frozen_balances: FrozenBalance[];
    onClose?: () => void;
}

export default class UserMenuBalance extends React.Component<UserBalanceInterface, UserBalanceState> {
    constructor(props: UserBalanceInterface) {
        super(props);
        this.state = {
            frozen_balances: props.frozen_balances
        };
    }

    componentDidUpdate(prevProps: UserBalanceInterface):void {
        if (prevProps.frozen_balances !== this.props.frozen_balances) {
            this.setState({frozen_balances: this.props.frozen_balances});
        }
    }

    handleTimerComplete = (): void => {
        requestAnimationFrame(() => {
            this.setState(({frozen_balances}) => ({
                frozen_balances: frozen_balances.slice(1)
            }));
        });
    };

    onClose = (): void => {
        this.props.onClose?.();
        closeMenuAndScrollToTop();
    };

    onDepositClick = (): void => {
        pushAnalyticsEvent('deposit_click', {
            placement: 'user_menu_balance'
        });
        this.onClose();
    };

    render(): React.ReactNode {
        const {frozen_balances} = this.state;
        const {bonus_balance, active_bets_sum} = this.props;
        const totalFrozen = frozen_balances.reduce((sum, b) => sum + Number(b.amount), 0);

        return <div className="balance">
            <div className="balance__heading">
                <AvatarEditorWithName editAvatar={this.props.editAvatar}/>
                <BalanceUserStatus
                    amountBalance={betMoney({amount: this.props.balance})}
                    amountActiveBets={betMoney({amount: active_bets_sum})}
                    amountBonusBalance={betMoney({amount: bonus_balance})}
                    amountFrozenBalance={betMoney({amount: totalFrozen})}
                    cashbackTooltip={<CashbackBalanceTooltip onClose={this.onClose}/>}
                    frozenTooltip={
                        <FrozenBalanceTooltip
                            frozenBalances={frozen_balances}
                            onExpire={this.handleTimerComplete}
                            onClose={this.onClose}
                        />
                    }
                    currentPercentCashback={userStore.user.cashback_real_rate}
                    onClose={this.onClose}
                />
                <div className="balance__btns">
                    <Link
                        to={getLinkPath('/deposits')}
                        onClick={this.onDepositClick}
                        className="btn"
                        dangerouslySetInnerHTML={{__html: I18n.t('user.deposit')}}
                    />
                    <Link
                        to={getLinkPath('/withdraws')}
                        onClick={this.onClose}
                        className="btn btn-withdraw"
                        dangerouslySetInnerHTML={{__html: I18n.t('user.withdraw')}}
                    />
                </div>
            </div>
        </div>;
    }
}
